import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class APIWebService {
  constructor(private http: HttpClient) {}
  getOrderDetailStages() {
    return this.http.get(API_URL + '/enums/order-detail-stages');
  }
  getLocalJsonChat() {
    return this.http.get('assets/json/chat.json');
  }
}
